<div data-testid="add-role-dialog-container" class="add-role-dialog p-3">
  <div class="space-y-4">
    <div class="field">
      <label class="block text-sm font-medium mb-1">{{
        "configuration.roles.dialog.name" | translate
      }}</label>
      <input
        data-testid="add-role-dialog-name-input"
        type="text"
        id="ard-name"
        pInputText
        [(ngModel)]="name"
        [placeholder]="
          'configuration.roles.dialog.name_placeholder' | translate
        "
        class="w-full"
        [ngClass]="{ 'ng-invalid ng-dirty': hasInvalidChars }"
      />
      @if (hasInvalidChars) {
        <small
          class="p-error block mt-1"
          style="color: var(--red-500, #ef4444)"
          >{{
            "configuration.roles.dialog.name_invalid_chars" | translate
          }}</small
        >
      }
    </div>

    <div class="field">
      <label for="ard-description" class="block text-sm font-medium mb-1">{{
        "configuration.roles.dialog.description" | translate
      }}</label>
      <input
        data-testid="add-role-dialog-description-input"
        type="text"
        pInputText
        [(ngModel)]="description"
        [placeholder]="
          'configuration.roles.dialog.description_placeholder' | translate
        "
        id="ard-description"
        class="w-full"
      />
    </div>

    <div class="flex justify-end gap-3 pt-4 border-t border-gray-200">
      <app-button
        [testId]="'add-role-dialog-cancel-btn'"
        [label]="'common.actions.cancel' | translate"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
      ></app-button>
      <app-button
        [testId]="'add-role-dialog-save-btn'"
        [label]="'common.actions.save' | translate"
        type="info"
        [disabled]="!isValid || loading()"
        [loading]="loading()"
        (emitOnClick)="onSave()"
      ></app-button>
    </div>
  </div>
</div>
